import * as yup from 'yup';
import {SendInvoicesToClientRequest} from "../../lib/types/types";


export const sendInvoicesToClientValidation: yup.SchemaOf<Omit<SendInvoicesToClientRequest, 'clientId' | 'filters'>> = yup.object({
    email: yup.array()
        .of(yup.string().email("Моля въведете валиден email").required("Моля въведете email"))
        .test({
            message: 'Трябва да изберете поне един адрес',
            test: arr =>  {
                if(!arr) return false;
                return arr.length > 0
            },
        })
})
